// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VirtualTicketSistema_wrapper__a65CB","bigWrapper":"VirtualTicketSistema_bigWrapper__g60NM","list":"VirtualTicketSistema_list__p7U95"};